import { Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { Button } from "../../components/Button";
import type { Offer, OpenShift, OpenShiftWorkplace } from "../../Shift/Open/types";
import { FallbackShiftsList } from "./FallbackShiftsList";
import { WorkerReferralCta } from "./WorkerReferralCta";
import { WorkplaceReferralCta } from "./WorkplaceReferralCta";

interface FallbackShiftsFooterProps {
  shifts: OpenShift[];
  workplacesMap: Map<string, OpenShiftWorkplace>;
  favoriteWorkplaceIds: Set<string>;
  onClickOpenShift: ({
    shift,
    workplace,
    offer,
  }: {
    shift: OpenShift;
    workplace: OpenShiftWorkplace;
    offer?: Offer;
  }) => void;
  onClearFilters: () => void;
}

/**
 * Footer component that displays fallback shifts when filters are applied
 * but return limited results (less than 10 shifts)
 */
export function FallbackShiftsFooter(props: FallbackShiftsFooterProps) {
  const { shifts, workplacesMap, onClickOpenShift, onClearFilters, favoriteWorkplaceIds } = props;

  return (
    <Stack sx={{ flex: "1", pt: 8, pb: 12 }} justifyContent="center" spacing={5}>
      <Title semibold variant="h4" component="h3" sx={{ textAlign: "center" }}>
        We&apos;re working on getting more shifts in your area!
      </Title>

      <Button
        variant="contained"
        size="medium"
        sx={{ width: "fit-content", alignSelf: "center" }}
        onClick={onClearFilters}
      >
        Reset filters to see all {shifts.length} shifts
      </Button>
      <Stack spacing={3}>
        <WorkerReferralCta />
        <WorkplaceReferralCta />
      </Stack>
      <FallbackShiftsList
        favoriteWorkplaceIds={favoriteWorkplaceIds}
        shifts={shifts}
        workplacesMap={workplacesMap}
        onClickOpenShift={onClickOpenShift}
      />
    </Stack>
  );
}
